import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css'; // Make sure the styles are included
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';

interface Props {
  title: string;
  description: string[];
  images: string[];
  className?: string;
}

const customStyle: Record<string, string> = { '--swiper-navigation-color': 'red' };
const ImageCarousel = (props: Props) => {
  const { title, description, images, className } = props;

  return (
    <div className={className ?? 'w-full max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg mb-8'}>
      <h2 className="text-3xl font-semibold mb-4">{title}</h2>
      {description.map((d, index) => (
        <p className={index === description.length - 1 ? 'mb-4' : 'mb-1'} key={`${index}`}>
          {d}
        </p>
      ))}
      <Swiper
        spaceBetween={20}
        modules={[FreeMode, Navigation, Thumbs]}
        style={customStyle}
        loop={false}
        navigation={true}
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="w-full h-60 sm:h-64 md:h-80 lg:h-120 bg-gray-100 rounded-lg">
              <img
                src={image}
                alt={`Imagine ${title} - ${index}`}
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageCarousel;
